export default __webpack_public_path__ + "static/media/Group 7124.288b27f6.svg";